import React, { useState } from "react";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import navigationsLinks from "../../constants/navigation_links";
import config from "../../config/config";
import { useDispatch } from "react-redux";
import { thunkLogoutUser } from "../../redux/reducers/user_info/userInfoReducer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

export default function SideBar(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const route = useRouteMatch();
  const [navState, setNavState] = useState(false);
  const getNavLabel = (route) => {
    if (route.path === "/dashboard") return "My Moves";
    if (route.path === "/my-profile") return "My Profile";
    return "";
  };
  const JSX = (
    <>
      <div className="col-sm-12 col-md-12 col-lg-2 sidebar-sticky-nav">
        <div className="dashboard-nav">
          <button
            className="btn btn-light navbar-toggler collapsed mr-2"
            onClick={() => setNavState(!navState)}
            type="button"
          >
            <FontAwesomeIcon icon={faBars} />
          </button>{" "}
          <h3 className="m-0"> {getNavLabel(route)} </h3>
        </div>
        <ul
          className={`p-0 sidebar-container ${
            navState === false ? "dashboard-side-nav-hidden" : ""
          }`}
        >
          <li
            className={`sidebar-links ${
              route.path === "/dashboard" ? "active-side-link" : ""
            }`}
          >
            <Link to={navigationsLinks.dashboard_page}>
              <span>
                <img
                  src={`${config.customerPortal}/includes/img/customerDashboard/my_moves.png`}
                  className="img-fluid"
                  alt="..."
                />
              </span>
              <span> MY MOVES</span>
            </Link>
          </li>
          <li
            className={`sidebar-links ${
              route.path === "/my-profile" ? "active-side-link" : ""
            }`}
          >
            <Link to={navigationsLinks.customer_profile_page}>
              <span>
                <img
                  src={`${config.customerPortal}/includes/img/customerDashboard/my_profile.png`}
                  className="img-fluid"
                  alt="..."
                />{" "}
              </span>
              <span> MY PROFILE </span>
            </Link>
          </li>
          <li className="sidebar-links">
            <Link to={navigationsLinks.move_details_page}>
              <span>
                <img
                  src={`${config.customerPortal}/includes/img/customerDashboard/create_estimate.png`}
                  className="img-fluid"
                  alt="..."
                />{" "}
              </span>
              <span> GET QUOTE </span>
            </Link>
          </li>
          <li className="sidebar-links">
            <button
              className="text-btn"
              onClick={() => {
                dispatch(
                  thunkLogoutUser({
                    status: false,
                    history: history,
                  })
                );
              }}
            >
              <span>
                <img
                  src={`${config.customerPortal}/includes/img/customerDashboard/logout.png`}
                  className="img-fluid"
                  alt="..."
                />
              </span>
              <span> LOGOUT </span>
            </button>
          </li>
        </ul>
      </div>
    </>
  );
  return JSX;
}
